import { render, staticRenderFns } from "./PollAd.vue?vue&type=template&id=2518ee25&scoped=true"
import script from "./PollAd.vue?vue&type=script&lang=js"
export * from "./PollAd.vue?vue&type=script&lang=js"
import style0 from "./PollAd.vue?vue&type=style&index=0&id=2518ee25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2518ee25",
  null
  
)

export default component.exports